//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

// custom pages
import auth from "apis/auth/auth";
import Context from "context/context";
import { customerLoginValidate } from "helpers/validateRules/auth";
import useForm from "helpers/useForm";
import { host } from "config/index";
import { customerLoginStyles } from "./styles";

// material-ui
import { makeStyles } from "@material-ui/core/styles";
import {
  Typography,
  Paper,
  TextField,
  Grid,
  Button,
  CssBaseline,
} from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import { IconButton } from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import IndeterminateCheckBoxIcon from "@material-ui/icons/IndeterminateCheckBox";

let initialValues = {
  integrationUserId: "",
  currentCustomerId: "",
  // associatedCustomerId: "",
  loyaltyAccountType: "",
  // userName: "",
  // password: "",
  role_details: {},
};

// const roles = [
//   { role_id: 3, role_name: "Sales Admin" },
//   { role_id: 4, role_name: "Marketing Admin" },
//   { role_id: 5, role_name: "Customer Care" },
//   { role_id: 6, role_name: "Tele Sales" },
//   { role_id: 7, role_name: "FSC" },
// ];

export default function CustomerLogin() {
  const { customerLogin, handleDllEncrypt, handleDllDecrypt, getAllRoles } =
    auth();
  const { state, dispatch } = useContext(Context);

  const history = useHistory();
  const classes = customerLoginStyles();

  const [states, setState] = useState({});
  const [encryptedData, setEncryptedData] = useState("");
  const [loyaltyInfo, setLoyaltyInfo] = useState();
  const [roles, setRoles] = useState([]);
  const [users, setUsers] = useState([
    {
      firstName: "",
      lastName: "",
      role: "",
      email: "",
      integration_user_id: "",
    },
  ]);
  const [requesterRole, setRequesterRole] = useState("");
  const [requesterEmail, setRequesterEmail] = useState("");

  // function handleChange(evt) {
  //   const value = evt.target.value;
  //   setState({
  //     ...states,
  //     [evt.target.name]: value,
  //   });
  // }

  // handling inputs
  const { values, errors, handleSubmit, handleChange, setUpdateValue } =
    useForm(initialValues, handleCustomerlogin, customerLoginValidate);

  // roles api func
  async function getRoles() {
    let res = await getAllRoles();
    if (res && res.type == "success") {
      setRoles(res.data);
    }
  }

  useEffect(() => {
    getRoles();
  }, []);

  // encrypting api func
  async function handleEncrypt() {
    const inputs = {
      users: JSON.stringify(users),
      requester: JSON.stringify({
        role: requesterRole,
        email: requesterEmail,
        current_customer_id: values.currentCustomerId,
      }),
      // associated_customer_id: JSON.stringify(values.associatedCustomerId),
      loyalty_account_type: values.loyaltyAccountType,
    };

    try {
      let res = await handleDllEncrypt(inputs);

      if (res && res.type == "success") {
        setEncryptedData(res.data);
      }
    } catch (e) {
      console.log({ e });
    }
  }

  // customer login api func
  async function handleCustomerlogin() {
    let inputs = {
      // first_name: values.firstName,
      // last_name: values.lastName,
      // password: states.password,
      // role: values.role,
      // email: values.email,
      // user_name: states.user_name,
      // current_customer_id: values.current_customer_id,
      // associated_customer_id: JSON.stringify(values.associated_customer_id),
      // integration_user_id: values.integration_user_id,
      // loyalty_account_type: values.loyalty_account_type,
      data: encryptedData,
    };

    try {
      let res = await customerLogin(inputs);
      if (res && res.type == "success") {
        if (res?.user?.role == "Customer") {
          let CA = [];
          CA = [res.user.current_customer_id];
          sessionStorage.removeItem("unauthorized");
          sessionStorage.setItem("token", res.token);
          dispatch({ type: "SET_USERINFO", payload: res.user });
          dispatch({ type: "SET_ISLOGGEDIN", payload: true });
          dispatch({ type: "SET_CUSTOMERACCOUNTS", payload: CA });
          dispatch({ type: "SET_LOADING", payload: false });
          setLoyaltyInfo(res.data);
          return;
        }
      }
      toast.error(
        res && res.message ? res.message : "something went wrong.",
        classes.toastCss
      );
    } catch (e) {
      console.log({ e });
    }
  }

  return (
    <React.Fragment>
      <div className={classes.mainDiv}>
        <CssBaseline />
        <Typography variant="h4" align="center" component="h1" gutterBottom>
          Customer Login
        </Typography>
        {!encryptedData && (
          <Paper className={classes.root}>
            <form
              action={`${host}/cdr-oneweb/thrive-signup`}
              method="POST"
              enctype="application/json"
            >
              <Grid container alignItems="flex-start" spacing={2}>
                <React.Fragment>
                  <Grid item xs={12} lg={6}>
                    <TextField
                      fullWidth
                      type="text"
                      label="First Name"
                      autoComplete="off"
                      // value={u.firstName}
                      // onChange={(e) => {
                      //   let value = [
                      //     ...users?.slice(0, i),
                      //     { ...users[i], firstName: e.target.value },
                      //     ...users?.slice(i + 1),
                      //   ];
                      //   setUsers(value);
                      // }}
                    />
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <TextField
                      fullWidth
                      type="text"
                      label="Last Name"
                      autoComplete="off"
                      // value={u.lastName}
                      // onChange={(e) => {
                      //   let value = [
                      //     ...users?.slice(0, i),
                      //     { ...users[i], lastName: e.target.value },
                      //     ...users?.slice(i + 1),
                      //   ];
                      //   setUsers(value);
                      // }}
                    />
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <TextField
                      fullWidth
                      type="text"
                      label="Email"
                      autoComplete="off"
                      // value={u.email}
                      // onChange={(e) => {
                      //   let value = [
                      //     ...users?.slice(0, i),
                      //     { ...users[i], email: e.target.value },
                      //     ...users?.slice(i + 1),
                      //   ];
                      //   setUsers(value);
                      // }}
                    />
                  </Grid>
                  <Grid item xs={12} lg={6} className={classes.inputRow}>
                    <TextField
                      select
                      fullWidth
                      label="Role"
                      className={classes.roleInput}
                      // value={u.role}
                      // onClick={(e) => {
                      //   let value = [
                      //     ...users?.slice(0, i),
                      //     { ...users[i], role: e.target.value },
                      //     ...users?.slice(i + 1),
                      //   ];
                      //   setUsers(value);
                      // }}
                    >
                      {roles &&
                        roles.length > 0 &&
                        roles?.map((r, i) => (
                          <MenuItem
                            value={r.role_name}
                            key={i}
                            // onClick={(e) => {
                            //   handleChange({
                            //     name: "role_details",
                            //     value: {
                            //       role_name: r.role_name,
                            //       role_id: r.role_id,
                            //     },
                            //   });
                            // }}
                          >
                            {r.role_name}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <TextField
                      fullWidth
                      type="text"
                      label="Integration User Id"
                      autoComplete="off"
                      // value={u.integration_user_id}
                      // onChange={(e) => {
                      //   let value = [
                      //     ...users?.slice(0, i),
                      //     {
                      //       ...users[i],
                      //       integration_user_id: e.target.value,
                      //     },
                      //     ...users?.slice(i + 1),
                      //   ];
                      //   setUsers(value);
                      // }}
                    />
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <TextField
                      fullWidth
                      type="number"  
  onWheel={(e) => e.target.blur()}                    
                      label="Current Customer No"
                      autoComplete="off"
                      value={values.currentCustomerId}
                      error={errors.currentCustomerId}
                      helperText={
                        errors.currentCustomerId && errors.currentCustomerId
                      }
                      onChange={(e) => {
                        handleChange({
                          name: "currentCustomerId",
                          value: e.target.value,
                        });
                      }}
                    />
                  </Grid>
                </React.Fragment>
                {/* <Grid item xs={12} lg={6} className={classes.inputRow}>
                  <TextField
                    select
                    fullWidth
                    label="Requester Role"
                    className={classes.roleInput}
                    value={requesterRole}
                    onClick={(e) => {
                      setRequesterRole(e.target.value);
                    }}
                  >
                    {["FSC", "Customer"].map((r, i) => (
                      <MenuItem value={r} key={i}>
                        {r}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid> */}
                {/* {requesterRole === "FSC" && (
                  <Grid item xs={12} lg={6}>
                    <TextField
                      fullWidth
                      type="text"
                      label="Requester Email"
                      autoComplete="off"
                      // value={requesterEmail}
                      // onChange={(e) => {
                      //   setRequesterEmail(e.target.value);
                      // }}
                    />
                  </Grid>
                )} */}

                {/* <Grid item xs={12} lg={6}>
                  <TextField
                    fullWidth
                    type="text"
                    label="Loyalty Account Type"
                    autoComplete="off"
                    // value={values.loyaltyAccountType}
                    error={errors.loyaltyAccountType}
                    helperText={
                      errors.loyaltyAccountType && errors.loyaltyAccountType
                    }
                    // onChange={(e) => {
                    //   handleChange({
                    //     name: "loyaltyAccountType",
                    //     value: e.target.value,
                    //   });
                    // }}
                  />
                </Grid> */}
                <Grid item xs={12} className={classes.inputRow}>
                  <div style={{ fontWeight: "bold", fontSize: 20 }}>
                    Web User Admin
                  </div>
                </Grid>
                <Grid item xs={12} lg={6}>
                  <TextField
                    fullWidth
                    type="text"
                    label="First Name"
                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <TextField
                    fullWidth
                    type="text"
                    label="Last Name"
                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <TextField
                    fullWidth
                    type="text"
                    label="Email"
                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={12} lg={6} className={classes.inputRow}>
                  <TextField
                    select
                    fullWidth
                    label="Role"
                    className={classes.roleInput}
                  >
                    {roles &&
                      roles.length > 0 &&
                      roles?.map((r, i) => (
                        <MenuItem value={r.role_name} key={i}>
                          {r.role_name}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} lg={6}>
                  <TextField
                    fullWidth
                    type="text"
                    label="Integration User Id"
                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={12} className={classes.inputRow}>
                  <div style={{ fontWeight: "bold", fontSize: 20 }}>
                    Web Billing Admin
                  </div>
                </Grid>
                <Grid item xs={12} lg={6}>
                  <TextField
                    fullWidth
                    type="text"
                    label="First Name"
                    autoComplete="off"
                    name="first_name"
                  />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <TextField
                    fullWidth
                    type="text"
                    label="Last Name"
                    autoComplete="off"
                    name="webAdminLastName"
                  />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <TextField
                    fullWidth
                    type="text"
                    label="Email"
                    autoComplete="off"
                    name="webAdminEmail"
                  />
                </Grid>
                <Grid item xs={12} lg={6} className={classes.inputRow}>
                  <TextField
                    select
                    fullWidth
                    label="Role"
                    className={classes.roleInput}
                    name="webAdminRole"
                  >
                    {roles &&
                      roles.length > 0 &&
                      roles?.map((r, i) => (
                        <MenuItem value={r.role_name} key={i}>
                          {r.role_name}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} lg={6}>
                  <TextField
                    fullWidth
                    type="text"
                    label="Integration User Id"
                    autoComplete="off"
                    name="webAdminIntegrationUserId"
                  />
                </Grid>
                <Grid item xs={12} lg={6} className={classes.inputRow} />
                <Grid item xs={12} lg={6} className={classes.inputRow}>
                  <TextField
                    select
                    fullWidth
                    label="Type"
                    name="request_type"
                    className={classes.roleInput}
                    // value={requesterRole}
                    // onClick={(e) => {
                    //   setRequesterRole(e.target.value);
                    // }}
                  >
                    {["Enrollment", "Transfer"].map((r, i) => (
                      <MenuItem value={r} key={i}>
                        {r}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={6} className={classes.submitBtnGrid}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    onClick={() =>
                      // console.log(errors)
                      {
                        // handleEncrypt();
                        sessionStorage.setItem("gowty", "qwerty");
                      }
                    }
                    className={classes.btn}
                  >
                    Enroll
                  </Button>
                </Grid>
                {/* <Grid item xs={6} className={classes.backBtnGrid}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              onClick={() => {
                history.goBack();
              }}
              className={classes.btn}
            >
              Back
            </Button>
          </Grid>
          <Grid item xs={6} className={classes.submitBtnGrid}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                handleSubmit();
              }}
              className={classes.btn}
            >
              Submit
            </Button>
          </Grid> */}
              </Grid>
            </form>
          </Paper>
        )}
      </div>
      <div className={classes.mainDiv}>
        {encryptedData && !loyaltyInfo && (
          <Paper className={classes.root}>
            <Grid container alignItems="flex-start" spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Encrypted Data"
                  type="text"
                  value={encryptedData}
                />
              </Grid>

              <Grid item xs={6} className={classes.backBtnGrid}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  onClick={() => {
                    handleCustomerlogin();
                  }}
                  className={classes.btn}
                >
                  Get Loyalty Info
                </Button>
              </Grid>
            </Grid>
          </Paper>
        )}

        {loyaltyInfo && (
          <Paper className={classes.root}>
            <Grid container alignItems="flex-start" spacing={2}>
              <Grid item xs={3}>
                <div>
                  <div style={{ color: "#707070", fontSize: 16 }}>
                    Customer Account No{" "}
                  </div>
                  <div style={{ color: "#000000", fontSize: 18 }}>
                    {loyaltyInfo.customer_account_number}
                  </div>
                </div>
              </Grid>
              <Grid item xs={3}>
                <div>
                  <div style={{ color: "#707070", fontSize: 16 }}>
                    Loyalty Id{" "}
                  </div>
                  <div style={{ color: "#000000", fontSize: 18 }}>
                    {loyaltyInfo.loyalty_id}
                  </div>
                </div>
              </Grid>
              <Grid item xs={3}>
                <div>
                  <div style={{ color: "#707070", fontSize: 16 }}>
                    Thrive Member{" "}
                  </div>
                  <div style={{ color: "#000000", fontSize: 18 }}>
                    {loyaltyInfo.thrive_member}
                  </div>
                </div>
              </Grid>
              <Grid item xs={3}>
                <div>
                  <div style={{ color: "#707070", fontSize: 16 }}>Tier </div>
                  <div style={{ color: "#000000", fontSize: 18 }}>
                    {loyaltyInfo.tier}
                  </div>
                </div>
              </Grid>

              <Grid item xs={6} className={classes.backBtnGrid}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  onClick={() => {
                    history.push("/dashboard/mydashboard");
                  }}
                  className={classes.btn}
                >
                  Go to Thrive
                </Button>
              </Grid>
              <Grid item xs={6} className={classes.submitBtnGrid}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {}}
                  className={classes.btn}
                >
                  Go to OneWeb
                </Button>
              </Grid>
            </Grid>
          </Paper>
        )}
        {/* <form
          action="http://localhost:8001/web/v1/cdr-login/dll-handler/encrypt"
          method="POST"
        >
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value="gowty"
          ></input>
          <button type="submit" class="btn btn-default">
            Submit
          </button>
        </form> */}
      </div>
    </React.Fragment>
  );
}
